import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Events, track } from 'utils/analytics';
import CtaArrowIcon from '../Hero/CtaArrowIcon';
import { LIFE_PROCESS_CONTENT } from './constants';
import ProcessBlockTitle from './ProcessBlockTitle';
import StepCard from './StepCard';
import { ReferralDesktopContainer } from '../styles';
import {
  CtaButton,
  CtaButtonContent,
  CtaContainer,
  Section,
  SectionBackground,
  StepsGrid,
  Subtitle,
  TitleSection,
} from './styles';
import { ProcessBlockContent, Props } from './types';

const ProcessBlock: React.FC<Props> = ({ agentUUID, ctaDestinationURL }) => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const [isTitleUnderlineVisible, setIsTitleUnderlineVisible] = useState(false);

  const quotesUrl =
    ctaDestinationURL || `${process.env.REACT_APP_LIFE_WEB_FLOW_URL}?agent_uuid=${agentUUID ?? ''}`;

  const openQuotes = useCallback(() => {
    track(Events.CLICKED_BUTTON, { analyticsText: 'Get Your Free Quote' });
    window.open(quotesUrl, '_blank')?.focus();
  }, [quotesUrl]);

  useEffect(() => {
    const el = sectionRef.current;

    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsTitleUnderlineVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  const { subtitle, steps, ctaLabel }: ProcessBlockContent = LIFE_PROCESS_CONTENT;

  return (
    <Section ref={sectionRef} aria-labelledby="referral-process-title">
      <ReferralDesktopContainer>
        <SectionBackground>
          <TitleSection>
            <ProcessBlockTitle isUnderlineVisible={isTitleUnderlineVisible} />
            <Subtitle>{subtitle}</Subtitle>
          </TitleSection>

          <StepsGrid>
            {steps.map((step, index) => (
              <StepCard key={step.header} step={step} stepNumber={index + 1} />
            ))}
          </StepsGrid>

          <CtaContainer>
            <CtaButton type="button" onClick={openQuotes} aria-label={ctaLabel}>
              <CtaButtonContent>
                {ctaLabel}
                <CtaArrowIcon />
              </CtaButtonContent>
            </CtaButton>
          </CtaContainer>
        </SectionBackground>
      </ReferralDesktopContainer>
    </Section>
  );
};

export default ProcessBlock;
